// extracted by mini-css-extract-plugin
export default {"root":"NotFound_root__t4aO4","link":"NotFound_link__srldp","content":"NotFound_content__qKmpp","image":"NotFound_image__1cyox"};